import {connect} from '@gisatcz/ptr-state';

import Action from "../../../state/Action";

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setBackgroundLayer: (definition) => {
            dispatch(Action.maps.setMapSetBackgroundLayer('risk-assessment', definition));
            dispatch(Action.maps.setMapSetBackgroundLayer('interferometry', definition));
        },
        setWmsLayers: (layers) => {
            dispatch(Action.maps.setMapSetLayers('risk-assessment', layers));
            dispatch(Action.maps.setMapSetLayers('interferometry', layers));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
